module.exports = "pegasus_template/assets/graycircle-snapchat.png";